enum LoginFormField {
  AccountId = 'accountId',
  RememberMe = 'rememberMe',
  Email = 'email',
  Password = 'password',
}

export default LoginFormField;
